import script from "./ConfirmedDrawdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmedDrawdown.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmedDrawdown.vue?vue&type=style&index=0&id=3c47de5a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c47de5a"]])

export default __exports__